export interface IProcessRetryExceededPaymentV2MutationResponse {
  processRetryExceededPaymentV2: number;
}

export const processRetryExceededPaymentV2Mutation = `
  mutation {
    processRetryExceededPaymentV2
  }
`;
